
export default function ActiveAssessmentDirective() {
  return {
    template: require('./active-assessment.html'),
    scope: {
      assessment: '=',
      isNavantaUser: '=',
    },
    controller: 'ECATActiveAssessmentController',
    controllerAs: 'activeAssessmentVM',
    bindToController: true,
    replace: true,
  };
}
